//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from "vuex";
import eventBus from "../services/eventBus";
import DashboardChart from "../components-v2/Dashboard/DashboardChart.vue";
import DeviceReport from "../components-v2/Dashboard/DeviceReport.vue";
import sharedMethods from "../sharedMethods";

export default {
  components: {
    DashboardChart,
    DeviceReport,
  },

  computed: mapGetters(["allMediaFiles", "allUserPlaylists"]),
  data() {
    return {
      username: "",
      vorname: "",
      slide: "style",
      accID: this.$store.getters.getUser.AccID,
      emailIsNotSet: false,
      userMailAdress: "",
      userMailRepeat: "",
      playlistsLoaded: false,
    };
  },
  mounted() {
    this.fetchMediaFiles();
    this.fetchAllUserPlaylists(true).then(() => {
      this.playlistsLoaded = true;
    });
    this.fetchDeviceGroups();
    this.accID = this.$store.getters.getUser.AccID;

    if (!this.$store.getters.getUser.email) this.emailIsNotSet = true;
  },
  beforeRouteLeave(to, from, next) {
    this.$tours["dashTour"].finish();
    this.setFirstUseState(false);
    next();
  },
  async created() {
    if (!this.$store.getters.isLoggedIn && this.$router.currentRoute.path !== "/login") {
      this.$router.push("/login");
    }
    if (this.getFirstUseState) this.startFirstUseTour = true;
    this.username = this.$store.getters.getUser.username;
    this.vorname = this.$store.getters.getUser.Vorname;
    this.accID = this.$store.getters.getUser.AccID;
  },
  methods: {
    ...mapActions(["fetchMediaFiles", "fetchDeviceGroups", "fetchAllUserPlaylists", "changeUserEmail", "setFirstUseState"]),

    showDeviceReport(deviceID) {
      this.$q.dialog({
        component: DeviceReport,
        root: this,
        deviceID: deviceID,
      });
    },

    setNewMail() {
      if (this.userMailAdress == this.userMailRepeat && this.userMailAdress.includes("@")) {
        console.log("MDE: ADRESS MATCHING, SEND DATA TO ENDPOINT");
        this.emailIsNotSet = false;

        this.changeUserEmail(this.userMailAdress).then((resp) => {
          if (resp.data.status == 200) {
            sharedMethods.successNotify(resp.data.msg);
          }
        });
      }
    },

    chooseFiles() {
      eventBus.$emit("chooseFilesForUpload");
    },

    logout() {
      this.$store.dispatch("logout");
    },
  },
};
